(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["preventivo-form"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('preventivo-teli')) {
  customElements.define('preventivo-teli', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.controller) return;
        const form = this.querySelector('form');
        if (!form) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const quantity = this.querySelector('[data-quantity]');
        const decrement = this.querySelector('[data-decrement]');
        const increment = this.querySelector('[data-increment]');
        const color = this.querySelector('[data-color]');
        const swatch = this.querySelector('[data-swatch]');
        const distance = this.querySelector('[data-distance]');
        const distanceGroup = this.querySelector('[data-distance-group]');
        const updateQuantity = () => {
          decrement.disabled = !Number.isFinite(quantity.valueAsNumber) || quantity.valueAsNumber <= 1;
        };
        const updateColor = () => {
          const hex = color.selectedOptions[0]?.dataset.hex;
          swatch.hidden = !hex;
          swatch.style.backgroundColor = hex || '';
        };
        const updateDistance = () => {
          const enabled = this.querySelector('[data-eyelets]:checked')?.dataset.eyelets === 'yes';
          distance.disabled = !enabled;
          distanceGroup.hidden = !enabled;
        };
        const changeQuantity = (delta) => {
          const current = quantity.valueAsNumber;
          quantity.value = String(Number.isFinite(current) ? Math.max(1, Math.floor(current) + delta) : 1);
          quantity.dispatchEvent(new Event('input', { bubbles: true }));
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        };
        decrement.hidden = false;
        increment.hidden = false;
        decrement.addEventListener('click', () => changeQuantity(-1), options);
        increment.addEventListener('click', () => changeQuantity(1), options);
        quantity.addEventListener('input', updateQuantity, options);
        color.addEventListener('change', updateColor, options);
        this.querySelectorAll('[data-eyelets]').forEach(radio => radio.addEventListener('change', updateDistance, options));
        const refresh = () => { updateQuantity(); updateColor(); updateDistance(); };
        window.addEventListener('pageshow', refresh, options);
        form.addEventListener('reset', () => queueMicrotask(refresh), options);
        refresh();
        this.querySelector('[data-result]')?.focus();
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
